export default __webpack_public_path__ + "static/media/Sync Completed.e1251f54.svg";